import React from 'react';
import { toast } from 'react-toastify';
import { UserModel } from '../../../app/modules/auth/models/UserModel';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';

type Props = {
  title: string;
  loading: boolean;
};

const EmptyResult: React.FC<Props> = ({ title, loading }) => {
  const user: UserModel = useSelector<RootState>(
    ({auth}) => auth.user,
    shallowEqual
  ) as UserModel;

  const pruebaCreandoCuenta = () => toast("Creando cuenta");
  return (
    <>
      <div
        className="card card-xl-stretch mb-xl-8"
        style={{ minHeight: '415px' }}
      >
        <section className={`text-center mt-10`}>
          <h1>Hola {user.company}</h1>
          <h2>Inicia operaciones creando una nueva cuenta</h2>
          <button className="btn btn-sm btn-light-primary" onClick={pruebaCreandoCuenta}>Crear nueva cuenta</button>
        </section>
        <div className="card-body d-flex align-items-center pt-3 pb-0">
          <div className="d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2">
            <div className="text-center">
              {loading && (
                <span
                  className="indicator-progress text-primary"
                  style={{ display: 'block' }}
                >
                  <div className="text-center mt-3">
                    <span className="spinner-border spinner-border-lg align-middle ms-2"></span>
                  </div>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { EmptyResult };






